export const READ = "read";
export const CREATE = "create";
export const UPDATE = "update";
export const DELETE = "delete";
